import {User} from '../models/User';
import {AuthorizationService, AuthorizationResult} from '../../../Services/authorization/AuthorizationService';

export class CheckDashboardAccessUseCase {
  private authorizationService: AuthorizationService;

  constructor () {
    this.authorizationService = AuthorizationService.getInstance();
  }

  execute (user: User | null): AuthorizationResult {
    return this.authorizationService.canAccessDashboard(user);
  }
}
